export default __webpack_public_path__ + "static/media/airbnb.908ac3ea.svg";